import api from '~/services/api';
import type { Contract as CardChangeContract } from '~/pages/contract/config/types/contratResponse';
import { normalizeRenewalContractBody } from '~/services/modules/renewal';

export type { CardChangeContract };

/** Organização Aride usada quando o link da troca de cartão não traz `org`. */
export const CARD_CHANGE_DEFAULT_ORG_ID = 'rw0Om';

function v2() {
  if (!api.v2) {
    throw new Error('API v2 não está disponível');
  }
  return api.v2;
}

/** Corpo do `GET Contracts/{hash}` sem contrato: o link não aponta para um contrato válido. */
export class CardChangeContractNotFoundError extends Error {
  constructor() {
    super('Contrato não encontrado');
    this.name = 'CardChangeContractNotFoundError';
  }
}

/** Contrato da troca de cartão pelo hash do link (`GET Contracts/{hash}`). */
export async function getCardChangeContract(hash: string, organizationId: string = CARD_CHANGE_DEFAULT_ORG_ID) {
  const params = new URLSearchParams({ organization_id: organizationId });
  const { data } = await v2().get(`Contracts/${hash}?${params.toString()}`);
  const contract = normalizeRenewalContractBody(data) as unknown as CardChangeContract | undefined;
  if (!contract) {
    throw new CardChangeContractNotFoundError();
  }
  return contract;
}

/**
 * Troca o cartão da assinatura com um token novo do Pagar.me: `PATCH Contracts/{hash}/card` para contrato no
 * cartão e `PATCH Contracts/{hash}/subscription` para boleto (que vira cartão), como a tela antiga.
 * ⚠️ `…/subscription` não existe hoje na V2 do api-core (CORE-988); a falha cai na tela de nova tentativa.
 */
export async function changeContractCard(
  hash: string,
  paymentMethod: CardChangeContract['payment_method'],
  cardToken: string,
  organizationId: string
) {
  const path = paymentMethod === 'boleto' ? `Contracts/${hash}/subscription` : `Contracts/${hash}/card`;
  await v2().patch(path, { card_token: cardToken, organization_id: organizationId });
}
